import { colors } from '@lmc/common/constants'
import React, { type ReactElement } from 'react'
import { Icon } from '../../../../general/Icon'
import { unstyledButton } from '../../../unstyledButton'

export type IconCellProps = {
  cellStyle?: object
  iconColor?: string
  iconName: string
  iconSize?: number
  onSelect?: () => void
}

export default function IconCell({
  cellStyle,
  iconColor = colors.black,
  iconName,
  iconSize = 24,
  onSelect
}: IconCellProps): ReactElement {
  const containerStyle = {
    ...styles.cell,
    ...(!!onSelect && { cursor: 'pointer' }),
    ...cellStyle
  }

  return (
    <button
      type="button"
      onClick={onSelect}
      style={{ ...unstyledButton, ...containerStyle }}
    >
      <Icon color={iconColor} name={iconName} size={iconSize} />
    </button>
  )
}

const styles = {
  cell: {
    display: 'flex',
    justifyContent: 'center'
  }
}
